import {careUnitActions, careUnitSelectors} from "../careUnit/redux";
import { reportActions, reportSelectors} from './redux'
import { sessionSelectors } from '../session/redux'
import { connect } from 'react-redux';
import { branch, compose, renderComponent } from 'recompose'
import Loading from '../../components/Loading'
import FakturaunderlagReport from './FakturaunderlagReport';
import lifeCycle from './FakturaunderlagReportLifecycle'

const mapStateToProps = (state) => ({
  events: reportSelectors.eventList(state),
  filter: reportSelectors.eventListFilter(state),
  careUnits: careUnitSelectors.careUnitList(state),
  loggedInUser: sessionSelectors.loggedInUser(state),
  errorMessage: reportSelectors.errorMessage(state),
  isLoading: reportSelectors.isLoading(state),
  // invoice: reportSelectors.invoice(state),
});

const mapDispatchToProps = (dispatch) => ({
  listEvents: () => dispatch(reportActions.listEvents()),
  listCareUnits: () => dispatch(careUnitActions.listCareUnits()),
  updateEventListFilter: (filter) => {
    dispatch(reportActions.updateEventListFilter(filter));
    dispatch(reportActions.listEvents())
  },
  createInvoice: () => dispatch(reportActions.createInvoice()),
  getCareUnit: (careUnitId) => dispatch(reportActions.getCareUnit(careUnitId)),
});

// Fixa Branch, behöver ladda när man väljer fakturaunderlag
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifeCycle,
  branch(({isLoading, events, errorMessage}) => isLoading || (!events && !errorMessage),
      renderComponent(()=><Loading title={'Laddar...'}/>)
  )
)(FakturaunderlagReport)